import React from 'react';
import { TextLink } from 'styles';

function EnterVIN() {
  return <TextLink primary>Or Enter With VIN</TextLink>;
}

export default EnterVIN;
